import React from "react";

export type TabItem<V extends string = string> = { value: V; label: React.ReactNode };

/**
 * Сегментные табы DS (canon-session 2026-07-24): пилюля-контейнер,
 * активный сегмент = accent-заливка. Управляемый (value/onChange).
 */
export function Tabs<V extends string = string>({
  items,
  value,
  onChange,
  size = "md",
}: {
  items: TabItem<V>[];
  value: V;
  onChange?: (value: V) => void;
  /** md (default) — крупный; sm — компактный для плотных шапок */
  size?: "sm" | "md";
}) {
  const sm = size === "sm";
  const segCls = sm ? "px-2.5 py-1 text-[11px]" : "px-4 py-2 text-[13px]";
  return (
    <div className={`inline-flex gap-1 rounded-full bg-bg-card border border-border ${sm ? "p-0.5" : "p-1"}`}>
      {items.map((it) => {
        const active = it.value === value;
        return (
          <button
            key={it.value}
            type="button"
            onClick={() => onChange?.(it.value)}
            className={`${segCls} rounded-full font-semibold press-scale ${
              active ? "bg-accent text-white" : "bg-transparent text-text-secondary hover:text-text-primary"
            }`}
          >
            {it.label}
          </button>
        );
      })}
    </div>
  );
}
